<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Sign In</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Sign In</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Start Sign in Area -->
<div class="sign-in-area ptb-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-8">
                <div class="text-center mb-4">
                    <div class="fs-3 text-black fw-semibold mb-2">Sign in to Your Account!</div>
                    <p class="text-muted mb-0">Enter your email and password to continue.</p>
                </div>

                <div class="card auth-card">
                    <div class="card-body p-4 p-md-5">
                        <form [formGroup]="loginForm">
                            <div class="mb-3">
                                <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                <input type="email" class="form-control" id="email" placeholder="Enter your email"
                                    formControlName="email">
                                <div class="text-danger small mt-2" *ngIf="loginForm.controls['email'].invalid &&
                                                        (loginForm.controls['email'].dirty ||
                                                            loginForm.controls['email'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="loginForm.controls['email'].errors.required">
                                        Please enter your email address!
                                    </span>
                                    <span *ngIf="loginForm.controls['email'].errors.email">
                                        Please enter a valid email address!
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input type="password" class="form-control" formControlName="password" id="password"
                                        placeholder="Enter your password" #passwordField>
                                    <button class="btn btn-outline-secondary" type="button" (click)="
                                                                        passwordField.type === 'password'
                                                                            ? (passwordField.type = 'text')
                                                                            : (passwordField.type = 'password')
                                                                    ">
                                        <i class="far fa-eye" *ngIf="passwordField.type === 'password'"></i>
                                        <i class="fa fa-eye-slash" *ngIf="passwordField.type === 'text'"></i>
                                    </button>
                                </div>
                                <div class="text-danger small mt-2" *ngIf="loginForm.controls['password'].invalid &&
                                                        (loginForm.controls['password'].dirty ||
                                                            loginForm.controls['password'].touched || isSubmit)
                                                    ">
                                    <span *ngIf="loginForm.controls['password'].errors.required">
                                        Please enter your password!
                                    </span>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mb-4">
                                <a routerLink="/forgot-password" class="text-decoration-none">Forgot password?</a>
                            </div>

                            <div class="text-center mb-4">
                                <button type="button" class="btn btn-blink" (click)="login()">
                                    <span>Sign In</span>
                                    <i class="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            <p class="text-center text-muted mb-0">
                                Not a member? <a routerLink="/sign-up" class="text-decoration-none fw-semibold">Sign Up</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Sign in  Area -->
